import React, { useEffect, useRef, createElement } from 'react';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
    fbqInitialized?: boolean;
  }
}
export function FacebookPixel() {
  const initialized = useRef(false);
  useEffect(() => {
    // Triple check to prevent any double initialization
    if (initialized.current || window.fbq || window.fbqInitialized) {
      return;
    }
    initialized.current = true;
    window.fbqInitialized = true;
    (function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize pixel - PageView is tracked automatically after init
    const initPixel = () => {
      if (window.fbq && !window.fbq.instance) {
        window.fbq('init', '724521340460408');
        // Mark that we've initialized to prevent double init
        window.fbq.instance = true;
      }
    };
    // Wait for script to load before initializing
    setTimeout(initPixel, 100);
    // Add noscript fallback only once
    if (!document.querySelector('noscript[data-fbpixel]')) {
      const noscript = document.createElement('noscript');
      noscript.setAttribute('data-fbpixel', 'true');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=724521340460408&ev=PageView&noscript=1';
      noscript.appendChild(img);
      if (document.body.firstChild) {
        document.body.insertBefore(noscript, document.body.firstChild);
      } else {
        document.body.appendChild(noscript);
      }
    }
  }, []);
  return null;
}